import { maskPhone } from "@/components/wizard/masks";

import type { FieldKind } from "./fields";

function maskAge(v: string) {
	return v.replaceAll(/\D/gu, "").slice(0, 3);
}

export function maskFor(kind: FieldKind) {
	if (kind === "tel") {
		return maskPhone;
	}

	if (kind === "number") {
		return maskAge;
	}

	return (v: string) => v;
}
